import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const Collapse: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="arrow-collapse" size={size} color={color} />
);
